var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 6,
    fill: "#FDF4E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 26C16.25 25.5858 16.5858 25.25 17 25.25H31C31.4142 25.25 31.75 25.5858 31.75 26C31.75 26.4142 31.4142 26.75 31 26.75H17C16.5858 26.75 16.25 26.4142 16.25 26Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 18C16.25 17.5858 16.5858 17.25 17 17.25H31C31.4142 17.25 31.75 17.5858 31.75 18C31.75 18.4142 31.4142 18.75 31 18.75H17C16.5858 18.75 16.25 18.4142 16.25 18Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon2);
export default __webpack_public_path__ + "static/media/sort-icon-2.dabc54468ec94e30917f907bd8270774.svg";
export { ForwardRef as ReactComponent };